<mat-tab-group>
  <mat-tab label="1">Content 1</mat-tab>
  <mat-tab label="2">Content 2</mat-tab>
  <mat-tab label="3">Content 3</mat-tab>
</mat-tab-group>
